<form [formGroup]="entityForm" (ngSubmit)="save()">
  <div class="row p-4">
    <div class="col-6">
      <div class="row mb-3" *ngIf="entity.id">
        <label [for]="'id-' + entity.id" class="col-sm-5 col-form-label">{{ 'ENTITY.DATABASE_ID' | translate }}</label>
        <div class="col-sm-7">
          <input type="text" class="form-control-plaintext" [id]="'id-' + entity.id" formControlName="id" readonly>
        </div>
      </div>

      <!-- div class="row mb-3">
        <label [for]="'internalCode-' + entity.id" class="col-sm-5 col-form-label">{{ 'ENTITY.INTERNAL_ID' | translate
          }}</label>
        <div class="col-sm-7">
          <input type="text" [class]="action === 'create' ? 'form-control' : 'form-control-plaintext'"
            [id]="'internalCode-' + entity.id" formControlName="internalCode">
          <hbo-control-messages [control]="entityForm.get('internalCode')!"></hbo-control-messages>
        </div>
      </div -->

      <div class="row mb-3">
        <label [for]="'entityTypeId-' + entity.id" class="col-sm-5 col-form-label">{{ 'COMMON.TYPE' | translate }}
          *</label>
        <div class="col-sm-7">
          <select [class]="action === 'create' ? 'form-select' : 'form-control-plaintext'"
            [id]="'entityTypeId-' + entity.id" formControlName="entityTypeId">
            <option value="2" [hidden]="user.roleId !== 1">{{ 'ENTITY_TYPE.2' | translate }}</option>
            <option value="3" [hidden]="user.roleId === 3 || user.roleId === 4">{{ 'ENTITY_TYPE.3' |
              translate }}</option>
            <option value="4" [hidden]="user.roleId === 4">{{ 'ENTITY_TYPE.4' | translate }}</option>
          </select>
          <hbo-control-messages [control]="entityForm.get('entityTypeId')!"></hbo-control-messages>
        </div>
      </div>

      <div class="row mb-3">
        <label [for]="'parentEntityId-' + entity.id" class="col-sm-5 col-form-label">{{ 'ENTITY.LOCATED' | translate }}
          *</label>
        <div *ngIf="user.roleId + 1 >= entity.entityTypeId" class="col-sm-7 align_middle">
          {{locatedBellow}}
        </div>
        <div *ngIf="!parentEntities.length && action === 'create'" class="col-sm-7 align_middle">
          {{user.roleId ===1 ? 'admin' : user.entity.name}}
        </div>
        <div *ngIf="parentEntities.length && !(user.roleId + 1 >= entity.entityTypeId) " class="col-sm-7">
          <!--<hbo-single-select-multi-level *ngIf="action === 'create' && configSvc.currentConfigValue.childEntities"
            [tree]="parentEntities" [typeData]="action === 'create' ? 'located' : 'locatedList'"
            [max]="action === 'create' ? reactiveToRole : entity.entityTypeId" [selection]="entity"
            formControlName="parentEntityId">
          </hbo-single-select-multi-level>-->
          <app-basic-virtual-scroll *ngIf="selectorVisible && configSvc.currentConfigValue.childEntities"
            [customTreeNode]="parentEntities" [parentEntityId]="persistParentEntity"
            (callback)="onChange($event,'entity')" [typeData]="action === 'create' ? 'located' : 'locatedList'"
            [entityType]="entity.entityTypeId"
            [currentEntityId]="entityForm.get('parentEntityId')!.value"></app-basic-virtual-scroll>
          <hbo-control-messages [control]="entityForm.get('parentEntityId')!"></hbo-control-messages>
        </div>
      </div>

      <div class="row mb-3">
        <label [for]="'name-' + entity.id" class="col-sm-5 col-form-label">{{ 'ENTITY.NAME' | translate }} *</label>
        <div class="col-sm-7">
          <input type="text" class="form-control" [id]="'name-' + entity.id" formControlName="name"
            [readonly]="((user.roleId === 2 && user.profileId===2) || user.entity.entityTypeId >= entity.entityTypeId) ? true : false">
          <hbo-control-messages [control]="entityForm.get('name')!"></hbo-control-messages>
        </div>
      </div>

      <div class="row mb-3">
        <label [for]="'identityCode-' + entity.id" class="col-sm-5 col-form-label">
          {{ 'ENTITY.CODE_ID' | translate }}
          <i class="bi bi-question-circle ms-2" data-bs-toggle="tooltip" data-bs-placement="right"
            data-bs-title="Code Entity ID"></i>
        </label>
        <div class="col-sm-7">
          <input type="text" class="form-control" [id]="'identityCode-' + entity.id" formControlName="identityCode"
            [readonly]="user.profileId===2 || (user.roleId !== 1 && user.roleId >= entity.entityTypeId)? true : false">
          <hbo-control-messages [control]="entityForm.get('identityCode')!"></hbo-control-messages>
        </div>
      </div>

      <!-- Se muestra el horizonsTeam si el usuario logado es admin y la entidad a visualizar/editar tiene tipo distribuidor o si se esta creando una entidad y el valor seleccionado de tipo es distribuidor  -->
      <div class="row mb-3"
        *ngIf="(user.roleId === 1 && entity.entityTypeId === 2) || (action === 'create' && entityForm.controls.entityTypeId.value === '2')">
        <label [for]="'horizonsTeamId-' + entity.id" class="col-sm-5 col-form-label">{{ 'USER.HORIZONS_TEAM' | translate
          }} *</label>
        <div class="col-sm-7">
          <ng-select *ngIf="horizonsTeams.length" [id]="'horizonsTeamId-' + entity.id" [searchable]="false"
            [clearable]="false" formControlName="horizonsTeamId" labelForId="yesno" [(ngModel)]="selectedHorizonsTeam"
            placeholder="{{'COMMON.HORIZONS_TEAM' | translate}}">
            <!--<ng-option [value]="0">{{'COMMON.ALL' | translate}}</ng-option>-->
            <ng-option *ngFor="let horizonsTeam of horizonsTeams"
              [value]="horizonsTeam.id">{{horizonsTeam.name}}</ng-option>
          </ng-select>
          <hbo-control-messages [control]="entityForm.get('horizonsTeamId')!"></hbo-control-messages>
        </div>
      </div>
      <!-- Se muestra el team si la entidad a visualizar/editar tiene rol oficinaCentral/optica o si se esta creando una entidad y el valor seleccionado de rol es oficinaCentral/optica  -->
      <div class="row mb-3"
        *ngIf="entityForm.controls.parentEntityId?.value && ([3,4].includes(entity.entityTypeId) || (action === 'create' && ['3','4'].includes(entityForm.controls.entityTypeId.value)))">
        <label [for]="'team-' + entity.id" class="col-sm-5 col-form-label">{{ 'USER.TEAM' | translate }} </label>
        <div *ngIf="!partialTeams.length" class="col-sm-7 align_middle">
          {{head_office_herency_team ? head_office_herency_team : ('COMMON.ALL' | translate)}}
        </div>
        <div class="col-sm-7">
          <ng-select *ngIf="partialTeams.length" [id]="'teamId-' + entity.id" [searchable]="false" [clearable]="false"
            formControlName="teamId" labelForId="yesno" [(ngModel)]="selectedTeam"
            placeholder="{{'COMMON.TEAM' | translate}}"
            [readonly]="(user.roleId === 2 && user.profileId===2) ? true : false">
            <ng-option [value]="0">{{'COMMON.ALL' | translate}}</ng-option>
            <ng-option *ngFor="let team of partialTeams" [value]="team.id">{{team.name}}</ng-option>
          </ng-select>
          <hbo-control-messages [control]="entityForm.get('teamId')!"></hbo-control-messages>
        </div>
      </div>

      <div class="row mb-3"
        *ngIf="user.roleId === 1 && user.profileId === 3 && (entity.entityTypeId === 4 || (action === 'create' && entityForm.controls.entityTypeId.value === '4'))">
        <label [for]="'isBase-' + entity.id" class="col-sm-5 col-form-label">{{ 'ENTITIES.IS_BASE' | translate }}</label>
        <div class="col-sm-7 d-flex align-items-center">
          <input type="checkbox" class="form-check-input" [id]="'isBase-' + entity.id" formControlName="isBase">
        </div>
      </div>

      <small>* {{ 'COMMON.MANDATORY' | translate }}</small>
    </div>

    <div class="col-6">
      <div class="row mb-3">
        <label [for]="'email-' + entity.id" class="col-sm-5 col-form-label">{{ 'ENTITY.EMAIL' | translate }}</label>
        <div class="col-sm-7">
          <input type="text" class="form-control" [id]="'email-' + entity.id" formControlName="email"
            [readonly]="(user.roleId === 2 && user.profileId===2) ? true : false">
          <hbo-control-messages [control]="entityForm.get('email')!"></hbo-control-messages>
        </div>
      </div>

      <div class="row mb-3">
        <label [for]="'phone-' + entity.id" class="col-sm-5 col-form-label">{{ 'ENTITY.PHONE' | translate }}</label>
        <div class="col-sm-7">
          <input type="text" class="form-control" [id]="'phone-' + entity.id" formControlName="phone"
            [readonly]="(user.roleId === 2 && user.profileId===2) ? true : false">
          <hbo-control-messages [control]="entityForm.get('phone')!"></hbo-control-messages>
        </div>
      </div>

      <div class="row mb-3">
        <label [for]="'contact-' + entity.id" class="col-sm-5 col-form-label">{{ 'ENTITY.CONTACT' | translate }}</label>
        <div class="col-sm-7">
          <input type="text" class="form-control" [id]="'contact-' + entity.id" formControlName="contact"
            [readonly]="(user.roleId === 2 && user.profileId===2) ? true : false">
          <hbo-control-messages [control]="entityForm.get('contact')!"></hbo-control-messages>
        </div>
      </div>

      <div class="row mb-3">
        <label [for]="'address-' + entity.id" class="col-sm-5 col-form-label">{{ 'ENTITY.ADDRESS' | translate }}</label>
        <div class="col-sm-7">
          <input type="text" class="form-control" [id]="'address-' + entity.id" formControlName="address"
            [readonly]="(user.roleId === 2 && user.profileId===2) ? true : false">
          <hbo-control-messages [control]="entityForm.get('address')!"></hbo-control-messages>
        </div>
      </div>

      <div class="row mb-3">
        <label [for]="'country-' + entity.id" class="col-sm-5 col-form-label">{{ 'ENTITY.COUNTRY' | translate }}</label>
        <div class="col-sm-7">
          <ng-select [id]="'country-' + entity.id" [searchable]="true" [clearable]="false" formControlName="country">
            <ng-option [value]="country.isoNumeric" *ngFor="let country of countries">{{ country.country }}</ng-option>
          </ng-select>
          <hbo-control-messages [control]="entityForm.get('country')!"></hbo-control-messages>
        </div>
      </div>

      <div class="row mb-3">
        <label [for]="'cityZipCode-' + entity.id" class="col-sm-5 col-form-label">{{ 'ENTITY.CITY' | translate
          }}</label>
        <div class="col-sm-7">
          <input type="text" class="form-control" [id]="'cityZipCode-' + entity.id" formControlName="cityZipCode"
            [readonly]="(user.roleId === 2 && user.profileId===2) ? true : false">
          <hbo-control-messages [control]="entityForm.get('cityZipCode')!"></hbo-control-messages>
        </div>
      </div>

      <div class="row mb-3">
        <label [for]="'timezone-' + entity.id" class="col-sm-5 col-form-label">{{ 'ENTITY.TIME_ZONE' | translate
          }}</label>
        <div class="col-sm-7">
          <ng-select [id]="'timezone-' + entity.id" [searchable]="true" [clearable]="false" formControlName="timezone">
            <ng-option [value]="timezone.timeZoneId" *ngFor="let timezone of timezones">(GMT {{ timezone.rawOffset }})
              {{ timezone.timeZoneId }}</ng-option>
          </ng-select>
          <hbo-control-messages [control]="entityForm.get('timezone')!"></hbo-control-messages>
        </div>
      </div>
    </div>
  </div>

  <div class="p-4" *ngIf="user.profileId !== 2">
    <button type="button" class="btn btn-outline-secondary me-2" (click)="cancel()">{{ 'COMMON.CANCEL' | translate
      }}</button>
    <button type="submit" class="btn btn-dark">{{ 'COMMON.SAVE_CHANGES' | translate }}</button>
    <!--<button type="button" class="btn btn-outline-secondary float-end" data-bs-toggle="modal"
      [attr.data-bs-target]="'#confirmationModal-' + entity.id" *ngIf="action === 'edit' && !(user.roleId === 1 && entity.entityTypeId === 1)">
      <i class="bi bi-trash3"></i> {{ 'COMMON.DELETE' | translate }}
    </button>-->
  </div>
</form>

<hbo-confirmation-modal [id]="entity.id" (confirm)="delete()"></hbo-confirmation-modal>